module.exports = __webpack_public_path__ + "static/img/The Devil.ac1f512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Devil.jpg
// module id = 1309
// module chunks = 0